var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tooltip",
    {
      attrs: {
        active: _vm.active,
        dashed: !!_vm.active,
        label: _vm.tooltip,
        size: _vm.size,
        type: _vm.type,
        position: _vm.position,
        multilined: "",
      },
    },
    [
      _vm.icon
        ? _c("dc-icon", { attrs: { icon: _vm.icon, library: _vm.library } })
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.label) + " "),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }